<template>
  <div class="form-associated form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="widget.readOnly"
      >
      <x-loading class="loading-box" :visible="loading">
        <div
          class="associated-list-box"
          :class="total > 0 && total <= 3 && !assocAllowNew ? 'list-btn-margin' : ''"
        >
          <template v-if="total > 0">
            <template v-for="(item, index) in listData">
              <form-list-card
                :key="index"
                :columns="columns"
                :data="item"
                @view-detail="viewDetail"
              ></form-list-card>
            </template>
          </template>
          <x-empty v-if="total === 0"></x-empty>
          <div class="list-btn">
            <div v-if="total > 3" class="check-all" @click="checkAll">
              <x-svg-icon name="x-lib-more"></x-svg-icon>查看全部
            </div>
            <div
              v-if="assocAllowNew && assocStatus && !isShareForm"
              class="add-new"
              @click="addNewAssociated"
            >
              <x-svg-icon name="x-lib-add"></x-svg-icon>添加记录
            </div>
          </div>
        </div>
      </x-loading>
      </x-proxy-form-item>
    </div>
  </div>
</template>

<script>
import FormListCard from '../form-list-card'
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import { mapAdapter } from '../form-build-action'
import {
  mapState,
  mapMutations
} from 'vuex'
export default {
  name: 'FormAssiciated',
  mixins: [FormWidgetConfigMixin],
  inject: ['$compRouter'],
  components: {
    FormListCard
  },
  inject: ['$compRouter'],
  data() {
    return {
      columns: [],
      listData: [],
      addPermission: true,
      total: 0,
      loading: false,
      compPayloadKey: this.$route.query.key,
    }
  },
  computed: {
    assocAllowNew() {
      return this.globalData.operationAuth !== 'READ' && (this.widget.assocAllowNew || false) && !this.widget.readOnly
    },
    isShareForm() {
      return this.$route.query && this.$route.query.readOnly
    },
    assocStatus() {
      return !this.$route.query.inTable || this.$route.query.inTable && this.formData[this.widget.associationField.originUuid]
    },
    ...mapState({
      compPayload: state => state.compRouterModule.compPayload
    }),
    formDetailData() {
      return this.compPayload[this.compPayloadKey].formData
    }
  },
  watch: {
    'widget.associationFormId': {
      handler(newVal, oldVal) {
        if (this.$route.query.formId && this.$route.query.documentId) {
          this.$nextTick(() => {
            this.initAssociatedConfig()
          })
        }
      }
    }
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initAssociatedConfig()
      }, 200)
    })
  },
  activated() {
    this.initAssociatedConfig()
  },
  methods: {
    ...mapAdapter(['initDefaultAssData']),
    initAssociatedConfig() {
      this.$nextTick(() => {
        const params = {
          formId: this.widget.associationFormId,
          page: 1,
          pageSize: 10
        }
        this.widget.inTable = this.$route.query.inTable
        if (this.widget.inTable) {
          this.widget.tableUuid = this.$route.query.tableUUID
          this.widget.originValue = this.formData[this.widget.associationField.originUuid]
        }
        if (this.widget.inTable && !this.widget.originValue) {
          return
        }
        if (this.globalData.formId && this.globalData.documentId) {
          this.loading = true
        }
        this.widget.queryTable(
          params,
          this.widget,
          this.globalData,
          (config) => {
            if (config.code === 'ok') {
              this.columns = config.data
            } else {
              this.columns = []
            }
          },
          (resp) => {
            if (resp.code === 'ok' && resp.data && resp.data.pageQueryResult) {
              this.listData = resp.data.pageQueryResult.result.slice(0, 3)
              this.total = resp.data.pageQueryResult.count
              this.addPermission = resp.data.addPermission
              this.loading = false
            } else {
              this.listData = []
              this.loading = false
            }
          }
        )
      })
    },
    checkAll() {
      this.$compRouter.push('associated-list', {
        key: this.propKey,
        operationAuth: this.globalData.operationAuth || '123',
        formId: this.$route.query.formId || this.globalData.formId,
        appId: this.$route.query.appId || this.globalData.appId,
        documentId: this.$route.query.documentId || this.globalData.documentId,
        queryData: {
          associationFormId: this.widget.associationFormId,
          targetUuid: this.widget.associationField.targetUuid,
          originUuid: this.widget.associationField.originUuid,
          inTable: this.widget.inTable,
          tableUUID: this.$route.query.tableUUID,
          originValue: this.formData[this.widget.associationField.originUuid]
        },
        widgetConfig: {
          ...this.widget
        },
        value: this.formValue,
        formData: this.$route.query.inTable ? this.formDetailData : this.formData
      })
    },
    addNewAssociated() {
      let defaultAssData = this.initDefaultAssData() || {}
      if (this.$route.name === 'associated-form') {
        this.$compRouter.push({
          name: 'form',
          query: {
            formId: this.widget.associationFormId,
            appId: this.$route.query.appId,
            originValueName: this.formData[this.widget.associationField.originUuid],
            targetUuid: this.widget.associationField.targetUuid,
            defaultAssData: JSON.stringify(defaultAssData)
          }
        }, {
          key: this.propKey,
          widgetConfig: this.widget,
          value: this.formValue
        })
      } else {
        this.$compRouter.push({
          name: 'associated-form',
          params: {
            formId: this.widget.associationFormId,
            orgId: this.$route.params.orgId || this.$route.query.tenantId
          },
          query: {
            formId: this.widget.associationFormId,
            appId: this.$route.query.appId,
            originValueName: this.formData[this.widget.associationField.originUuid],
            targetUuid: this.widget.associationField.targetUuid,
            defaultAssData: JSON.stringify(defaultAssData)
          }
        }, {
          key: this.propKey,
          widgetConfig: this.widget,
          value: this.formValue,
          // 根据分享表单操作权限判断表单类型
          formType: this.globalData.operationAuth === 'READ' ? 'DETAIL_FORM' : 'EDIT_FORM'
        })
      }
    },
    viewDetail(data) {
      this.$compRouter.push({
        name: 'associated-form',
        params: {
          formId: this.widget.associationFormId,
          orgId: this.$route.params.orgId || this.$route.query.tenantId // 分享表单中
        },
        query: {
          formId: this.widget.associationFormId,
          documentId: data.documentId,
          appId: this.$route.query.appId
        }
      }, {
        key: this.propKey,
        widgetConfig: this.widget,
        value: this.formValue,
        // 根据分享表单操作权限判断表单类型
        formType: this.globalData.operationAuth === 'READ' ? 'DETAIL_FORM' : 'EDIT_FORM'
      })
    }
  }
}
</script>

<style lang="scss">
.form-associated {
  .form-item-content {
    position: relative;
    z-index: 1;
    .list-btn-margin {
      margin-bottom: 0.57rem;
    }
    .associated-list-box {
      .list-card {
        box-shadow: 0px 0px 8px 0px #ebeef5;
      }
      .list-btn {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: -0.57rem;
        margin-top: -0.57rem;
        color: #303133;
        .x-svg-icon {
          display: flex;
          align-items: center;
        }
        .check-all {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: normal;
          height: 3.571rem;
        }
        .add-new {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: normal;
          height: 3.571rem;
        }
      }
      .x-empty {
        padding-bottom: 0.857rem;
      }
    }
    .loading-box {
      > img {
        width: 50%;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>